<template>
  <div
    style="height: 100%;"
    class="pa-4"
  >
    <portal to="app-header">
      <a
        href="https://developer.mozilla.org/en-US/docs/Web/CSS/mix-blend-mode"
        class="mr-2"
      >
        mix-blend-mode MDN
      </a>
    </portal>
    <router-view />
  </div>
</template>

<script>

export default {
}
</script>

<style>

</style>